export default {"src":"/_next/static/media/0xb5102cee1528ce2c760893034a4603663495fd72.e0a56871.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};